import PropTypes from 'prop-types';
import ClickToInput from 'components/controls/click-to-input';
import SelectedContactsString from 'components/formatting/selected-contacts-string';
import EmmaListTimestamp from 'apps/lists/components/emma-list-timestamp';
import ListActions from 'apps/lists/components/list-actions';
import CollaboratorIconList from 'apps/lists/components/collaborator-icon-list';

const ListHeaderController = ({
  list,
  isOwner,
  listContacts,
  selectedContacts,
  groups,
  accounts,
  handleSaveListName,
  handleRemove,
  refresh,
  listId,
  handleCreateList,
  isAllSelected,
  filterParams = {},
  hasActiveFilters = false,
  listContactIds = [],
}) => {
  return (
    <>
      <div className="list-detail--header">
        <div className="list-detail--description">
          <div className="list-detail--label">
            {isOwner && list?.name !== 'Favorites' ? (
              <ClickToInput value={list?.name} onSave={handleSaveListName} />
            ) : (
              <h1 tabIndex={-1}>{list?.name}</h1>
            )}
          </div>

          <div className="list-detail--info">
            <SelectedContactsString
              selected={isAllSelected ? listContacts?.total : selectedContacts?.length}
              results={listContacts?.total}
            />
            <EmmaListTimestamp groups={groups} accounts={accounts} />
          </div>
        </div>

        <div className="list-detail--actions">
          <ListActions
            list={list}
            resultCount={listContacts?.total}
            selectedContacts={isAllSelected ? listContactIds : selectedContacts}
            onRemove={handleRemove}
            emma_groups={groups}
            emma_accounts={accounts}
            onEmmaChange={refresh}
            onCreateList={handleCreateList}
            isAllSelected={isAllSelected}
            filterParams={filterParams}
            hasActiveFilters={hasActiveFilters}
          />
        </div>
      </div>

      <div className="list-detail--sub-header">
        <CollaboratorIconList listId={listId} />
      </div>
    </>
  );
};

ListHeaderController.propTypes = {
  list: PropTypes.object,
  isOwner: PropTypes.bool,
  listContacts: PropTypes.object,
  selectedContacts: PropTypes.array,
  groups: PropTypes.array,
  accounts: PropTypes.array,
  handleSaveListName: PropTypes.func,
  handleRemove: PropTypes.func,
  refresh: PropTypes.func,
  listId: PropTypes.any,
  handleCreateList: PropTypes.func,
  isAllSelected: PropTypes.bool,
  filterParams: PropTypes.object,
  hasActiveFilters: PropTypes.bool,
  listContactIds: PropTypes.array,
};

export default ListHeaderController;
